import { useQuery, type QueryKey } from '@tanstack/react-query';
import service from '../service';
import type { Soul } from '@Types/soul';

export const soulKeys = {
  all: ['souls'] as const,
  detail: (id: string) => ['soul', id] as const,
};

export function useSouls({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery<Soul[]>({
    queryKey: soulKeys.all as unknown as QueryKey,
    queryFn: () => service.getSouls(),
    enabled,
  });
}

export function useSoul({
  soulId,
  enabled = true,
}: {
  soulId?: string;
  enabled?: boolean;
}) {
  return useQuery<Soul>({
    queryKey: soulKeys.detail(soulId!) as unknown as QueryKey,
    queryFn: () => service.getSoul(soulId!),
    enabled: enabled && !!soulId,
  });
}
